import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { Tag, TagType } from './Tag';
import InfoRow from '../ProductDetail/InfoRow';
import { __, __r } from 'react-i18n';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { IsInCartAlready } from '../ProductDetail/LeftUpper';
import { AlreadyOrderedText } from '../Cart/Items/ItemsTabRow';

export interface Props {
  name: string;
  imgSrc: string;
  price: string;
  currency: string;
  unit: string;
  url: string;
  onClick: any;
  searchTerm: string;
  isQuickBuy?: boolean;
  issale?: boolean;
  isInCart?: boolean;
  theme: any;
  isOrdered?: boolean;
}

function ProductSearchItem({
  name,
  imgSrc,
  url,
  price,
  currency,
  unit,
  searchTerm,
  onClick,
  isQuickBuy,
  issale,
  isInCart,
  theme,
  isOrdered,
}: Props) {
  const parts = name.split(new RegExp(`(${searchTerm})`, 'gi'));

  return (
    <>
      {isInCart && (
        <IsInCartAlready>
          {__('Produkt sa nachádza v košíku')}
          <SvgIcon
            icon={IconType.cart}
            fill={theme.colors.primary}
            marginLeft={8}
            alt={__('Produkt sa nachádza v košíku')}
            title={__('Produkt sa nachádza v košíku')}
          />
        </IsInCartAlready>
      )}
      {isOrdered && (
        <>
          <StyledLink
            to={__r(
              'routes:moj-ucet/nedodany-tovar',
              '/moj-ucet/nedodany-tovar',
            )}
          >
            <AlreadyOrderedText>
              {__('Produkt už máte objednaný')}
            </AlreadyOrderedText>
          </StyledLink>
          <br />
        </>
      )}
      {isQuickBuy && issale && (
        <Tag
          style={{
            marginRight: rem(4),
            width: 'fit-content',
            marginTop: rem(16),
            marginBottom: rem(16),
          }}
          text={'Akcia'}
          type={TagType.ACTION}
        />
      )}
      <Wrapper>
        <ImageNameWrapper isQuickBuy={isQuickBuy} onClick={onClick} to={url}>
          <Image alt={`Obrázok ku produktu ${name}`} src={imgSrc} />
          <Name isQuickBuy={isQuickBuy}>
            {parts &&
              parts.map((part, i) =>
                part.toLowerCase() === searchTerm.toLowerCase() ? (
                  <HighlightedText key={i}>{part}</HighlightedText>
                ) : (
                  part
                ),
              )}
          </Name>
        </ImageNameWrapper>
        {price ? <Price>{`${price} ${currency} / ${unit}`}</Price> : null}
      </Wrapper>
    </>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  margin-bottom: ${rem(16)};
  justify-content: space-between;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ImageNameWrapper = styled(Link)<{ isQuickBuy?: boolean }>`
  display: flex;
  flex-flow: row;
  align-items: center;
  width: ${({ isQuickBuy }) => (isQuickBuy ? '' : '65%')};
  margin-right: ${rem(32)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;

  ${({ theme }) => theme.mediab.l1150`
    margin-right: ${rem(8)};
  `}
`;

const Image = styled.img`
  width: ${rem(32)};
  height: ${rem(32)};
  margin-right: ${rem(16)};
  flex-shrink: 0;
`;

const Name = styled(TextP)<{ isQuickBuy?: boolean }>`
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(22)};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  white-space: ${({ isQuickBuy }) => (isQuickBuy ? '' : 'nowrap')};
  overflow: ${({ isQuickBuy }) => (isQuickBuy ? '' : 'hidden')};
  text-overflow: ${({ isQuickBuy }) => (isQuickBuy ? '' : 'ellipsis')};

  &:hover {
    text-decoration: underline;
  }

  ${({ theme, isQuickBuy }) => theme.mediab.s450`
    max-width: ${isQuickBuy ? 'unset' : rem(130)};
  `}
`;

const Price = styled(TextP)`
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.placeholder};
  white-space: nowrap;
`;

const HighlightedText = styled.span`
  background-color: ${({ theme }) => theme.colors.highlight};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  width: fit-content;
`;

const WithTheme: any = withTheme(ProductSearchItem);
export { WithTheme as ProductSearchItem };
